// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as StoryItem$AppTemplateReasonReact from "../components/StoryItem/StoryItem.bs.js";
import * as Composable$AppTemplateReasonReact from "../composable/Composable.bs.js";

import './HomePage.css';
;

function HomePage(Props) {
  var match = Composable$AppTemplateReasonReact.useStories(undefined);
  var getStories = match[1];
  React.useEffect((function () {
          Curry._1(getStories, undefined);
          
        }), []);
  var renderStories = Belt_Array.map(match[0], (function (story) {
          return React.createElement(StoryItem$AppTemplateReasonReact.make, {
                      id: story.objectID,
                      title: story.title,
                      url: story.url,
                      points: story.points,
                      author: story.author,
                      createdAt: story.created_at,
                      numberOfComments: story.num_comments,
                      key: story.objectID
                    });
        }));
  return React.createElement(React.Fragment, undefined, React.createElement("div", {
                  className: "stories"
                }, renderStories), React.createElement("div", undefined, "This website use Algolia Search's API ", "please see ", React.createElement("a", {
                      href: "https://hn.algolia.com/api"
                    }, "this doc")));
}

var make = HomePage;

export {
  make ,
  
}
/*  Not a pure module */
